import { React, useState, useEffect } from 'react';
import styled from 'styled-components';

import ExitButtonIcon from '../../image/GrayExitIcon.png';
import LinkPayIcon from '../../image/LinkPayIcon.png';
import OnSiteIcon from '../../image/OnSiteIcon.png';

export default function LinkoPayPaymentModal(props) {
  const {
    onClickOnSitePayment,
    onClickLinkoPay, 
    onClickExit
  } = props;

  const [isInProgress, setIsInProgress] = useState(false);
  const [hover, setHover] = useState('LinkPay');

  // 스크롤 제어 //
  useEffect(() => {
    document.body.style = `overflow: hidden`;
    return () => document.body.style = `overflow: auto`;
  }, [])

  return (
    <TopLevelWrapper>
      <LinkPayModal>
        <PayTopLineWrapper>
          <NoneButton />
          <PayIconWrapper backgroundColor={hover === 'LinkPay' ? '#6DD49E' : '#FF8B48'}>
            {
              hover === 'LinkPay' ?
                <PayIcon src={LinkPayIcon} width={52} height={52} />
                :
                <PayIcon src={OnSiteIcon} width={44} height={44} />
            }
          </PayIconWrapper>
          <ExitIconButton onClick={onClickExit}>
            <ExitButton style={{ width: '16px', height: '16px' }} src={ExitButtonIcon} />
          </ExitIconButton>
        </PayTopLineWrapper>
        {
          hover === 'LinkPay' ?
            <PayTextWrapper>
              <Text fontFmaily='NotoSansKR-Bold' fontSize={16} color='#232323'>링크페이 문자 발송</Text>
              <Text style={{ marginTop: '8px' }} fontFmaily='NotoSansKR-Medium' fontSize={12} color='#232323'>회원님들이 바로 결제 할수 있도록</Text>
              <Text fontFmaily='NotoSansKR-Medium' fontSize={12} color='#232323'>카카오 알림톡을 보내드려요</Text>
            </PayTextWrapper>
            :
            <PayTextWrapper>
              <Text fontFmaily='NotoSansKR-Bold' fontSize={16} color='#232323'>현장 결제 등록</Text>
              <Text style={{ marginTop: '8px' }} fontFmaily='NotoSansKR-Medium' fontSize={12} color='#232323'>현장 결제 수단으로</Text>
              <Text fontFmaily='NotoSansKR-Medium' fontSize={12} color='#232323'>회원권 결제를 진행합니다</Text>
            </PayTextWrapper>
        }
        <SelectButtonWrapper>
          <SelectButton onClick={onClickOnSitePayment} onMouseOver={() => setHover('OnSite')} backgroundColor={hover === 'OnSite' ? '#FF8B48' : '#CFCFCF'}>
            <Text fontFmaily='NotoSansKR-Bold' fontSize={16} color='#FFFFFF'>현장 결제</Text>
          </SelectButton>
          <SelectButton onClick={onClickLinkoPay} onMouseOver={() => setHover('LinkPay')} backgroundColor={hover === 'LinkPay' ? '#6DD49E' : '#CFCFCF'}>
            <Text fontFmaily='NotoSansKR-Bold' fontSize={16} color='#FFFFFF'>링코 페이</Text>
          </SelectButton>
        </SelectButtonWrapper>
      </LinkPayModal>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  z-index: 1100;

  width: 100vw;
  height: 100vh;

  background-color: rgba(0, 0, 0, 0.3);

  transition: all 0.3s ease-in-out;
`;

const LinkPayModal = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  width: 354px;
  height: 200px;

  border-radius: 16px;
  background-color: #FFFFFF;
`;

const PayTopLineWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  margin-top: -40px;

  width: 100%;
`;

const PayIconWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 86px;
  height: 86px;

  border-radius: 86px;
  background-color: ${props => props.backgroundColor};

  transition: all 0.3s ease-in-out;
`;

const PayIcon = styled.img`
  width: ${props => props.width}px;
  height: ${props => props.height}px;

  object-fit: contain;
`;

const ExitIconButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin: 24px 12px 0px 0px;

  width: 16px;
  height: 16px;

  :hover {
    cursor: pointer;
  }
`;

const NoneButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin: 24px 12px 0px 0px;

  width: 16px;
  height: 16px;
`;

const PayTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: 12px;
`;

const SelectButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  margin-top: 28px;

  width: 100%;
  height: 52px;

  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;

  overflow: hidden;
`;

const SelectButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 50%;
  height: 100%;

  background-color: ${props => props.backgroundColor};

  transition: all 0.3s ease-in-out;

  :hover {
    cursor: pointer;
  }
`;

const ExitButton = styled.img`
  width: 16px;
  height: 16px;

  :hover {
    cursor: pointer;
  }
`;

const Text = styled.div`
  font-family: ${props => props.fontFmaily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  transition: all 0.3s ease-in-out;

  :hover {
    cursor: ${props => props.cursor};
  }
`;